//
//
//
//
//
//
//
//

// import _ from 'underscore'

export default {
  props: {
    rows: {
      default: 4
    },
    value: {
      default: ''
    },
    maxLength: {
      default: 200
    }
  },
  data: function () {
    return {
      length: 0,
      currentValue: this.value
    }
  },
  watch: {
    value: {
      handler (val) {
        if (this.currentValue !== val) {
          this.currentValue = val
        }
      }
    },
    currentValue: {
      handler (val) {
        this.length = this.countWord(val, this.maxLength)
        if (this.value !== val) {
          this.$emit('input', val)
        }
      },
      immediate: true
    }
  },
  mounted () {

  },
  methods: {
    countWord (s, max) {
      let len = 0
      if (s) {
        len = s.replace(/\n/g, 'aa').length
      }
      return len > max ? max : len
    }
  }
}
